import * as Yup from 'yup';

export const retrievePrequalificationSchema = Yup.object({
  referenceNumber: Yup.string()
    .required('Required')
    .test('len', 'Must be exactly 6 characters', val => val?.length === 6),
});
